export enum ThirdPartySsoTokenIssuer {
    mira = 'mira',
    zorgdossier = 'zorgdossier',
}
